<svelte:head>
  <meta name="robots" content="noindex, nofollow" />
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="" />
  <link href="https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@700&display=swap" rel="stylesheet" />
</svelte:head>

<div class="lotr-wrap">
  <a
    href="https://drive.google.com/file/d/1gbCbbJyf5sAI79ZCdOkCwva0tn0pG5H9/view?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    class="lotr-link"
  >
    The Fellowship of the Ring
  </a>
</div>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@700&display=swap');

  .lotr-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 60px);
  }

  .lotr-link {
    font-family: 'Cinzel Decorative', serif;
    font-size: 2rem;
    font-weight: 700;
    color: #c8a96e;
    text-decoration: none;
    letter-spacing: 0.08em;
    text-align: center;
    text-shadow:
      0 0 18px rgba(200, 169, 110, 0.55),
      0 0 40px rgba(200, 169, 110, 0.25);
    transition: color 0.3s, text-shadow 0.3s;
  }

  .lotr-link:hover {
    color: #e8cc92;
    text-shadow:
      0 0 24px rgba(232, 204, 146, 0.75),
      0 0 60px rgba(232, 204, 146, 0.35);
  }

  @media (max-width: 600px) {
    .lotr-link {
      font-size: 1.3rem;
      padding: 0 1.5rem;
    }
  }
</style>
